<template lang="html">
  <section class="comp-ctn-docs row">
		<tile-doc :doc="doc" v-for="(doc, key) in documents" v-bind:key="key" />
		<div class="no-data" v-if="documents.length === 0">
			Pas encore de documents à votre disposition
		</div>
  </section>
</template>

<script>
import TileDoc from '@/common/components/tile-doc'
export default {
	name: 'JustificatoryDocuments',
	components: {
		TileDoc
	},
	data () {
		return {
			documents: []
		}
	},
	mounted () {
		this.documents = this.$store.getters.typeDocuments('justificatifs')
	}
}
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// src/components/MyDocuments/Justificatory.vue